import { render } from "./AdminEditTicket.vue?vue&type=template&id=3d487586&scoped=true"
import script from "./AdminEditTicket.vue?vue&type=script&lang=js"
export * from "./AdminEditTicket.vue?vue&type=script&lang=js"

import "./AdminEditTicket.vue?vue&type=style&index=0&id=3d487586&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d487586"]])

export default __exports__